<div id="layoutSidenav">
    <div id="layoutSidenav_content">
        <main>

            <div class="container-fluid px-5 pt-5 mt-4">
                <h2 class="mb-4 leads-title">Leads ({{ totalRecords || 0 }})</h2>

                <div class="container-fluid mt-3 pb-2">
                    <div class="row g-2 align-items-center filter-row">
                        <div class="col-md-3">
                            <div class="input-group search-group">
                                <input type="text" class="form-control" placeholder="Name, Email, Mobile"
                                    [(ngModel)]="filters.search" name="search" />
                                <button *ngIf="filters.search" class="clear-btn" (click)="clearSearch()">✕</button>
                            </div>
                        </div>

                        <div class="col-md-2" *ngIf="lookupModel.getLoggedUser().type == 'franchise' || lookupModel.getLoggedUser().type == 'subfranchise'">
                            <select class="form-select" [(ngModel)]="filters.staffName" name="staff"
                                (change)="selectStaff($event)">
                                <option value="0">-- Select Staff --</option>
                                <option *ngFor="let staff of allStaffRecords" [value]="staff.franchiseId">{{
                                    staff.personalDetails.firstName }}</option>
                            </select>
                        </div>

                        <div class="col-md-2">
                            <select class="form-select" [(ngModel)]="filters.status" name="status">
                                <option value="0">-- Select Status --</option>
                                <option *ngFor="let s of statusList" [value]="s.value">{{ s.name }}</option>
                            </select>
                        </div>

                        <div class="col-md-2">
                            <select class="form-select" [(ngModel)]="filters.category" name="category">
                                <option value="0">-- Select Category --</option>
                                <option *ngFor="let c of mainModules" [value]="c.mainModuleId">{{ c.moduleName }}</option>
                            </select>
                        </div>

                        <div class="col-md-3 d-flex gap-2 filter-actions">
                            <button type="button" class="btn btn-primary w-100 d-flex align-items-center justify-content-center"
                                (click)="applyFilters()">
                                <i class="fa fa-search me-2"></i> Search
                            </button>
                            <button type="button" class="btn btn-secondary w-100 d-flex align-items-center justify-content-center"
                                (click)="resetFilters()">
                                <i class="fa fa-refresh me-2"></i> Reset
                            </button>
                        </div>
                    </div>
                </div>

                <div class="leads-btns">
                    <button class="btn me-2" [ngClass]="{
                                'btn-gold': selectedServiceType === 'realEstate',
                                'btn-outline-light': selectedServiceType !== 'realEstate'
                              }" (click)="selectService('realEstate')">
                        Real Estate ({{ totalRecords || 0 }})
                    </button>

                    <button class="btn me-2" [ngClass]="{
                                'btn-gold': selectedServiceType === 'finTech',
                                'btn-outline-light': selectedServiceType !== 'finTech'
                              }" (click)="selectService('finTech')">
                        FinTech
                    </button>

                    <button class="btn me-2" [ngClass]="{
                                'btn-gold': selectedServiceType === 'propService',
                                'btn-outline-light': selectedServiceType !== 'propService'
                              }" (click)="selectService('propService')">
                        Prop Services
                    </button>
                </div>

                <div class="table-responsive thtdfix">
                    <table class="table table-hover">
                        <thead class="table-primary">
                            <tr>
                                <th>S.No</th>
                                <th>Property</th>
                                <th>Lead ID</th>
                                <th>Category</th>
                                <th>Lead Type</th>
                                <th>Customer Name</th>
                                <th>Mobile Number</th>
                                <th>Email ID</th>
                                <th>Product</th>
                                <th>Product Value</th>
                                <th>Status</th>
                                <th>Remarks</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            <ng-container *ngFor="let leadRec of leads; let i = index">
                                <tr>
                                    <td>{{ i + 1 }}</td>
                                    <td class="property-info-cell">
                                        <div class="property-info-display">
                                            <img [src]="leadRec.images.length ? leadRec?.images[0] : ''" class="property-info-icon" />
                                            {{ generateTitle(leadRec) }}
                                        </div>
                                    </td>

                                    <td>{{ leadRec?.leadId }}</td>
                                    <td>
                                        <span [ngClass]="getCategoryClass(leadRec?.mainModuleName || leadRec?.serviceType)">
                                            {{ leadRec?.mainModuleName || leadRec?.serviceType }}
                                        </span>
                                    </td>
                                    <td>
                                        <span [ngClass]="getLeadTypeClass(leadRec?.leadType)">{{ leadRec?.leadType || 'Online' }}</span>
                                    </td>
                                    <td>{{ leadRec?.customerName }}</td>
                                    <td>{{ leadRec?.mobile }}</td>
                                    <td>{{ leadRec?.email }}</td>
                                    <td>
                                        <span [ngClass]="getProductClass(leadRec?.product)">{{ leadRec?.product }}</span>
                                    </td>
                                    <td>{{ leadRec?.productValue }}</td>
                                    <td>
                                        <ng-container *ngIf="editIndex === i; else displayRemark" style="cursor: pointer;">
                                            <select [(ngModel)]="editRowValues[i].status" #statusCtrl="ngModel" required>
                                                <option value="0">Select Value</option>
                                                <option *ngFor="let option of statusList" [value]="option.value">
                                                    {{ option.name }}
                                                </option>
                                            </select>
                                            <div *ngIf="(statusCtrl.invalid && statusCtrl.touched) || (editRowValues[i].status === '0' && saveAttempted)"
                                                class="text-danger small mt-1">
                                                Please select a valid status.
                                            </div>
                                        </ng-container>
                                        <ng-template #displayRemark>
                                            <span (click)="startEditingRow(i)">{{ getStatusName(leadRec.status) || 'Verified Lead' }}</span>
                                        </ng-template>
                                    </td>

                                    <td>
                                        <span [title]="leadRec?.remarks" style="cursor: pointer;"
                                            [ngClass]="getStatusClass(leadRec?.remarks)">
                                            <ng-container *ngIf="editIndex === i; else displayRemarks">
                                                <input type="text" name="remarks{{ i }}" [(ngModel)]="editRowValues[i].remarks"
                                                    #remarksCtrl="ngModel" required minlength="5" autofocus style="height:50px;" />
                                                <div *ngIf="remarksCtrl.invalid && (remarksCtrl.touched || saveAttempted)" class="text-danger small mt-1">
                                                    <span *ngIf="remarksCtrl.errors?.required">Remarks are required.</span>
                                                    <span *ngIf="remarksCtrl.errors?.minlength">Must be at least 5 characters.</span>
                                                </div>
                                            </ng-container>

                                            <ng-template #displayRemarks>
                                                <span (click)="startEditingRow(i)">{{ leadRec.remarks }}</span>
                                            </ng-template>
                                        </span>
                                    </td>
                                    <td>
                                        <button class="btn btn-sm btn-outline-primary me-2" *ngIf="editIndex !== i"
                                            (click)="startEditingRow(i)">
                                            <i class="fa-solid fa-pen-to-square"></i>
                                        </button>
                                        <button class="btn btn-sm btn-outline-primary me-2" *ngIf="editIndex !== i" (click)="toggleRow(i)">
                                            <i class="fa-solid fa-clock-rotate-left"></i>
                                        </button>
                                        <button class="btn btn-sm btn-outline-primary me-2" *ngIf="editIndex == i"
                                            (click)="saveRemark(leadRec, i)"><i class="fa-solid fa-check"></i></button>
                                        <button class="btn btn-sm btn-outline-primary me-2" *ngIf="editIndex == i"
                                            (click)="closeEdit(i)"><i class="fa-solid fa-xmark" style="color: red;"></i></button>
                                    </td>
                                </tr>
                                <ng-container *ngIf="expandedIndex === i">
                                    <tr>
                                        <td colspan="13" class="bg-light">
                                            <div class="p-2 border w-75 bg-white rounded-1 m-auto text-wrap td-data">
                                                <a (click)="toggleRow(i)" style="cursor: pointer;"><i class="fa-solid fa-chevron-up text-right d-block mb-2"></i></a>
                                                <p *ngFor="let history of childData" class="mb-1">
                                                    <b>{{ history.createdAt | date:'short':'IST' }}:</b>
                                                    {{ history.remarks }} - <b>Status</b>: <b class="text-primary" style="color: green;">{{ getStatusName(history.status) }}</b>
                                                </p>
                                            </div>
                                        </td>
                                    </tr>
                                </ng-container>
                            </ng-container>
                        </tbody>
                    </table>
                </div>

                <mat-paginator [length]="totalRecords" [pageSize]="pageSize" showFirstLastButtons
                    (page)="onPageChange($event)">
                </mat-paginator>
            </div>
        </main>
    </div>
</div>